// MarketingSection.jsx
import { motion } from "framer-motion";
import "../styles/MarketingSection.css";

const textVariant = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.3,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

export default function MarketingSection({ image, title, sections }) {
  return (
    <div className="marketing-section">
      <motion.img
        src={image}
        alt="Marketing Blog Image"
        className="main-image"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      />

      <motion.h1
        className="main-title"
        variants={textVariant}
        initial="hidden"
        animate="visible"
        custom={1}
      >
        {title}
      </motion.h1>

      {sections.map((section, index) => (
        <motion.div
          key={index}
          className={
            section.type === "quote"
              ? "blockquote-container"
              : section.className
          }
          variants={textVariant}
          initial="hidden"
          animate="visible"
          custom={index + 2}
        >
          {section.type === "quote" ? (
            <>
              <div className="quote-line"></div>
              <blockquote>{section.content}</blockquote>
            </>
          ) : section.type === "heading" ? (
            <h2>{section.content}</h2>
          ) : section.type === "list" && Array.isArray(section.content) ? (
            <div>
              {/* If first item is a section title, show it separately */}
              {section.content.length > 1 &&
              !section.content[0].includes(":") ? (
                <>
                  <p>{section.content[0]}</p>
                  <ul>
                    {section.content.slice(1).map((item, idx) => {
                      const [strongText, ...rest] = item.split(":");
                      const remainingText = rest.join(":").trim();
                      return (
                        <li key={idx}>
                          <strong>{strongText.trim()}:</strong> {remainingText}
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : (
                <ul>
                  {section.content.map((item, idx) => {
                    const [strongText, ...rest] = item.split(":");
                    const remainingText = rest.join(":").trim();
                    return (
                      <li key={idx}>
                        <strong>{strongText.trim()}:</strong> {remainingText}
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ) : Array.isArray(section.content) ? (
            <ul>
              {section.content
                .filter((item) => item.trim() !== "")
                .map((item, idx) => (
                  <li key={idx}>{item.replace(/^•\s*/, "")}</li>
                ))}
            </ul>
          ) : (
            <p>{section.content}</p>
          )}
        </motion.div>
      ))}
    </div>
  );
}
